import { render, staticRenderFns } from "./newBooks.vue?vue&type=template&id=6e4e68ef&scoped=true&"
import script from "./newBooks.vue?vue&type=script&lang=js&"
export * from "./newBooks.vue?vue&type=script&lang=js&"
import style0 from "./newBooks.vue?vue&type=style&index=0&id=6e4e68ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e68ef",
  null
  
)

export default component.exports